<div class="cpcontent">
    <h2>Beacon Sensor Scenario Consistency Checker</h2>
    A beacon is assigned to an organization<br>
    A scenario is assigned to an organization<br>
    A beacon is assigned to a scenario<br>
    <b>It can happen that the organization assigned to a beacon is different than the organization assigned to a scenario that uses the beacon!</b>
<br><br>
<button class="btn btn-primary" (click)="refresh()">Refresh</button>
    <button class="btn btn-primary" style="margin-left:20px" (click)="showAll()">Show All</button>
    <button class="btn btn-primary" style="margin-left:20px" (click)="showInconsitency()">Show Inconsistencies</button>
    
    <br><br>
    {{scenbeaconsensorsdisplay.length}} records
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Id</th>
                <th>Delete</th>
                <th>Reassign</th>
                <th>BeaconId <i class="bi bi-arrow-down-up" style="margin-left:10px" (click)="sortCol('beaconId')"></i></th>
                <th>SensorId</th>
                <th>ScenarioId <i class="bi bi-arrow-down-up" style="margin-left:10px" (click)="sortCol('scenarioId')"></i></th>
                <th>BeaconOrgId</th>
                <th>BeaconOrgName</th>
                <th>BeaconName</th>
                <th>SensorName</th>
                <th>ScenarioName</th>
                <th>ScenarioOrgId</th>
                <th>ScenarioOrgName</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let s of scenbeaconsensorsdisplay">
                <td>{{s.id}}</td>
                <td><i class="bi bi-trash" style="margin-left:10px;color:orange" (click)="delete(s)"></i></td>
                <td><i class="bi bi-pencil" style="margin-left:10px;color:blue" (click)="reassign(s)"></i></td>

                <td>{{s.beaconId}}</td>
                <td>{{s.sensorId}}</td>
                <td>{{s.scenarioId}}</td>
                <td>{{s.beaconOrganizationId}}</td>
                <td>{{s.beaconOrgName}}</td>
                <td>{{s.beaconName}}</td>
                <td>{{s.sensorName}}</td>
                <td>{{s.scenarioName}}</td>
                <td>{{s.scenarioOrganizationId}}</td>
                <td>{{s.scenarioOrgName}}</td>
            </tr>
        </tbody>
    </table>

</div>